module.exports = __webpack_public_path__ + "fd5a608a/img/team.68b3d85e.png";